module.exports = __webpack_public_path__ + "media/83.01594775.wav";